import axios from "axios";
import { SERVER_URL } from "../socket";

export async function loadBookmarks(authHeaders) {
  const res = await axios.get(`${SERVER_URL}/api/bookmarks`, { headers: authHeaders });
  return res.data;
}

export async function createBookmark(payload, authHeaders) {
  const res = await axios.post(`${SERVER_URL}/api/bookmarks`, payload, { headers: authHeaders });
  return res.data;
}

export async function updateBookmark(id, payload, authHeaders) {
  const res = await axios.put(`${SERVER_URL}/api/bookmarks/${id}`, payload, { headers: authHeaders });
  return res.data;
}

export async function deleteBookmark(id, authHeaders) {
  const res = await axios.delete(`${SERVER_URL}/api/bookmarks/${id}`, { headers: authHeaders });
  return res.data;
}
